import moment from 'moment-timezone';
import { duration } from 'moment';

function isAmPm(locale) {
  const testMoment = moment().locale(locale);
  const isAmPm = testMoment.format('LT');

  return isAmPm.endsWith('AM') || isAmPm.endsWith('PM');
}

function humanReadableTime(seconds, flat = false) {
  /* eslint-disable no-underscore-dangle */
  const parsedTime = duration(seconds, 'seconds');
  const days = Math.floor(parsedTime.asDays());
  const timeParts = [];
  if (days) {
    if (seconds === 86400) {
      timeParts.push(flat ? '24h' : '<span class="highlight">24h</span>');
    } else {
      timeParts.push(flat ? `${days}d` : `<span class="highlight">${days}d</span>`);
    }
  }
  if (parsedTime._data.hours) {
    timeParts.push(flat ? `${parsedTime._data.hours}h` : `<span class="highlight">${parsedTime._data.hours}h</span>`);
  }

  if (parsedTime._data.minutes) {
    timeParts.push(flat ? `${parsedTime._data.minutes}m` : `<span class="highlight">${parsedTime._data.minutes}m</span>`);
  }
  if (parsedTime._data.seconds) {
    timeParts.push(flat ? `${parsedTime._data.seconds}s` : `<span class="highlight">${parsedTime._data.seconds}s</span>`);
  }
  /* eslint-enable no-underscore-dangle */

  const lastTimePart = timeParts.pop();
  let timeString = timeParts.join(', ');
  if (lastTimePart) timeString += timeParts.length ? ` and ${lastTimePart}` : lastTimePart;
  return timeString;
}

export { isAmPm, humanReadableTime };
